<template>
    <wizard-step-card
            header="Bitte geben Sie weitere Details an!"
            :reason="_getCurrentReason"
            v-on:stepdone="stepDone"
            v-on:abbort="$emit('abbort')"
    >

        <div class="row">

            <div class="col-6 offset-3">

                <info-header icon="far fa-edit">
                    <template slot="titel">
                        Ihre Mitteilung an uns
                    </template>

                    <template slot="leed">
                        Bitte teilen Sie uns mit, wie wir Ihnen Helfen können!
                    </template>
                </info-header>

                <customer-discription name="additionalText" v-on:setText="_setText"> </customer-discription>

            </div>

        </div>

    </wizard-step-card>
</template>

<script>
    import InfoHeader from '../../elements/InfoHeader'
    import WizardStepCard from '../../elements/WizardStepCard'
    import CustomerDiscription from '../../elements/CustomerDiscription'

    export default {
        name: "message",
        components: {
            WizardStepCard,
            InfoHeader,
            CustomerDiscription
        },

        computed: {
            _getCurrentReason () {

                let reasonCode = this.$store.getters.getReason

                return this.$store.getters.getReasons[ reasonCode ] || 'Fehler - nicht gefunden!'
            },
        },

        methods: {

            _setText (obj) {

                let { name, value } = obj

                this.$store.commit('setText', { name, value })
            },

            stepDone () {

                // Form validation
                const form = this.$store.getters.getForm

                // Check text && length
                if( !form.text.additionalText || form.text.additionalText < 20 ){
                    this.$swal({
                        title: 'FEHLER',
                        text: 'Ihre Mitteilung enthält zu wenige Zeichen!',
                        icon: 'error'
                    })

                    return
                }

                this.$emit('stepdone')
            }
        }
    }
</script>

<style scoped>

</style>